import { css } from '@emotion/react';
import { Box, Button, styled } from '@mui/joy';
import { Fragment } from 'react';

import AngleUpIcon from '@/assets/icons/angle-up.svg?react';
import AddActiveIcon from '@/assets/icons/button-decorators/add-active.svg?react';
import AddIcon from '@/assets/icons/button-decorators/add.svg?react';
import RadmelderLogo from '@/assets/logos/radmelder-combo.svg?react';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { useCreateReportStore } from '@/stores/useCreateReportStore';

const StyledButton = styled(Button)(
  ({ theme }) => css`
    padding-inline: ${theme.spacing(3)};

    .MuiButton-startDecorator {
      margin-right: ${theme.spacing(2)};
    }

    .MuiButton-endDecorator {
      display: none;
      margin-left: auto;
    }

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      justify-content: flex-start;

      .MuiButton-endDecorator {
        display: flex;
      }
    }
  `,
);

export function CreateReportStart() {
  const expanded = useCreateReportStore((state) => state.expanded);
  const { toggleExpanded } = useCreateReportStore((state) => state.actions);

  return (
    <Fragment>
      <Box sx={{ px: 3, py: 4, display: { xs: 'none', [MAIN_BREAKPOINT]: 'block' } }}>
        <RadmelderLogo />
      </Box>

      <Box
        sx={(theme) => ({
          margin: { xs: theme.spacing(2), [MAIN_BREAKPOINT]: 0 },
        })}
      >
        <StyledButton
          fullWidth
          endDecorator={<AngleUpIcon style={expanded ? {} : { transform: 'rotate(180deg)', stroke: 'white' }} />}
          onClick={toggleExpanded}
          startDecorator={expanded ? <AddActiveIcon /> : <AddIcon />}
          variant={expanded ? 'soft' : 'solid'}
          sx={(theme) => ({
            '--Button-radius': { [MAIN_BREAKPOINT]: 0 },
            '--Button-minHeight': { [MAIN_BREAKPOINT]: theme.spacing(7) },
          })}
        >
          Neue Meldung
        </StyledButton>
      </Box>
    </Fragment>
  );
}
